import { render, staticRenderFns } from "./Investigate.vue?vue&type=template&id=2b993966"
import script from "./Investigate.vue?vue&type=script&lang=js"
export * from "./Investigate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports